<template>
  <VLoader v-if="loading" />
  <section v-else class="shared-section account">
    <header class="shared-section-header">
      <h2 class="shared-section-header-heading">
        {{ $t('account.header.heading') }}
      </h2>
    </header>

    <!-- shared settings fields -->
    <Settings :user="user" @save="handleSave" />

    <!-- customer specific extra settings fields from here down -->
    <div class="account-field">
      <div class="account-field-name">{{ $t('account.settings.fields.language') }}</div>
      <LanguageSelect
        @set="handleSaveLanguage"
        :initialLangCode="user.lang_code"
        :classes="{ container: 'w-40 h-12 text-base border-ricoma-orange-100' }"
      />
    </div>
  </section>
</template>

<script>
import { capitalize } from '@/utils';

import VLoader from '@/components/base/VLoader';
import Settings from '@/components/shared/Settings';
import LanguageSelect from '@/components/shared/LanguageSelect';

export default {
  name: 'Account',
  components: { VLoader, Settings, LanguageSelect },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user() {
      const u = this.$user;
      return {
        firstName: u.first_name ? capitalize(u.first_name) : '',
        lastName: u.last_name ? capitalize(u.last_name) : '',
        email: u.email,
        lang_code: u.lang_code,
      };
    },
  },
  methods: {
    // only update language if user's language does not equal selected language
    async handleSaveLanguage({ code: lang_code }) {
      if (lang_code !== this.user.lang_code) {
        await this.$store.dispatch('auth/updateCustomerAccount', { lang_code });
      }
    },
    async handleSave({ firstName, lastName, email, password }) {
      this.loading = true;
      const name = { first_name: firstName, last_name: lastName };
      const data = password ? { ...name, email, password } : { ...name, email };
      await this.$store.dispatch('auth/updateCustomerAccount', data);
      this.loading = false;
    },
  },
};
</script>
